import { QueryConfig } from 'redux-query';
import { getHeaders } from '../../../helpers/request/getHeaders';
import { IOrderItem, IReturnCustomer, IReturnOrder } from 'components/OrderReturns/ReturnForm';

export interface IOrderCredentials {
    orderNumber: string;
    email?: string;
    phone?: string;
    captchaToken?: string;
}

interface IOrderLoadResponse {
    order?: {
        items: IOrderItem[];
        customer: IReturnCustomer;
    };
    error?: string;
}

interface IOrderReturnEntities {
    orderReturn?: IReturnOrder;
    orderReturnError?: string;
}

const loadOrderRequest = (credentials: IOrderCredentials): QueryConfig<IOrderReturnEntities> => {
    const { orderNumber, email, phone, captchaToken } = credentials;
    const query = new URLSearchParams({ orderNumber });

    if (email) {
        query.append('email', email);
    }
    if (phone) {
        query.append('phone', phone);
    }

    const headers = getHeaders();
    if (captchaToken) {
        headers['X-ReCaptcha'] = captchaToken;
    }

    return {
        url: `${window.API_URL}/orderreturns/form/orderLoader?${query.toString()}`,
        options: {
            method: 'GET',
            headers,
        },
        transform: (response: IOrderLoadResponse): IOrderReturnEntities => ({
            orderReturn: response?.order
                ? {
                      orderNumber,
                      customer: response.order.customer,
                      products: response.order.items.map((item) => ({
                          ...item,
                          returnQuantity: item.orderedQuantity,
                          selected: false,
                      })),
                  }
                : undefined,
            orderReturnError: response?.order ? undefined : response?.error,
        }),
        update: {
            orderReturn: (prev, next) => next,
            orderReturnError: (prev, next) => next,
        },
    };
};

export default loadOrderRequest;
